import React from "react";
import ReactDOM from "react-dom/client";

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Home from "./components/Home";
import { Toaster } from 'react-hot-toast';
import "./styles.css";
import "./components/cancer-care/cancer-care.css";
import KeyBenefits from "./components/cancer-care/KeyBenefits";
import EvaluatePersona from "./components/cancer-care/EvaluatePersona";
import GenerateBI from "./components/cancer-care/GenerateBi";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Toaster
    position="top-right"
    reverseOrder={false}
    />
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/key-benefits" element={<KeyBenefits />} />
        <Route path="/evaluate-persona" element={<EvaluatePersona />} />
        <Route path="/generate-bi" element={<GenerateBI />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
